import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api.js";

const formulario_api = {
    getList: (filtros = { status: "", finalidade: "" }) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Formulario/getlist/", filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Formulario/getitem/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postFormulario: (formulario) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Formulario/PostFormulario/", formulario)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putFormulario: (formulario) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Formulario/PutFormulario/", formulario)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postFormularioQuestao: (questao) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Formulario/PostFormularioQuestao/", questao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putFormularioQuestao: (questao) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Formulario/PutFormularioQuestao/", questao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    deleteFormularioQuestao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE("Formulario/DeleteFormularioQuestao/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default formulario_api;
